export enum UserPassScanStatusEnum {
  FINAL = 'FINAL',
  TEMPORARY = 'TEMPORARY'
}
